var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecentIcon06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.922852,
    width: 60,
    height: 60,
    rx: 10,
    fill: "#FFF6F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9229 18C24.2947 18 18.9229 23.3719 18.9229 30V41.25C18.9229 41.6656 19.2572 42 19.6729 42H25.4229C26.526 42 27.4229 41.1031 27.4229 40V33.5C27.4229 32.3969 26.526 31.5 25.4229 31.5H21.1729V30C21.1729 24.6156 25.5385 20.25 30.9229 20.25C36.3072 20.25 40.6729 24.6156 40.6729 30V31.5H36.4229C35.3197 31.5 34.4229 32.3969 34.4229 33.5V40C34.4229 41.1031 35.3197 42 36.4229 42H42.1729C42.5885 42 42.9229 41.6656 42.9229 41.25V30C42.9229 23.3719 37.551 18 30.9229 18ZM25.1729 33.75V39.75H21.1729V33.75H25.1729ZM40.6729 39.75H36.6729V33.75H40.6729V39.75Z",
    fill: "#FE4A23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentIcon06);
export default __webpack_public_path__ + "static/media/recent-icon-06.b63993887aa3b9fef385d45c888ce4d5.svg";
export { ForwardRef as ReactComponent };